import React, { useState } from "react";

import Api from "../../../lib/componentApi";
import getAppErrors from "../../../lib/appErrors";
import getAppStrings from "../../../lib/appStrings";

import AppErrors from "../../Common/AppErrors";
import AppInfo from "../../Common/AppInfo";

import PhoneInput from "../../Common/PhoneInput";
import CountdownTimer from "../../Common/CountdownTimer";

const SmsVerification = ({
  handleChangeInput,
  onCloseSection,
  handleVerificateSms,
  sms1,
  sms2,
  sms3,
  sms4,
  sendSmsVerificationKey,
  onTimeout,
  mobileNumber,
  handleChangeMobileNumber,
  changeNumber,
  sendKeyAfterChangedNumber,
  route
}) => {
  const [newMobileNumber, setMobileNumber] = useState(mobileNumber);
  const [activeButton, setButtonActive] = useState(!!mobileNumber);
  const [errorMessage, setErrorMessage] = useState(false);
  const [info, setInfo] = useState({ message: "", title: "" });
  const submitPhoneNumber = (newMobileNumber, error) => {
    if (!error) {
      setMobileNumber(newMobileNumber);
      setButtonActive(true);
    } else {
      setButtonActive(false);
    }
  };
  const onClose = () => {
    if (route === "checkout") {
      const info = getAppStrings(4037) || {
        message:
          "In order to use the Local E app you need to verify your phone number.",
        title: "Verification Needed"
      };
      setInfo(info);
    } else {
      onCloseSection();
    }
  };
  const saveNewNumber = () => {
    Api.post(
      "/api/profile/info/singular",
      { mobileNumber: newMobileNumber },
      (response, errors) => {
        var body = document.body;
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          const errorMessage = getAppErrors(response.code);
          body.classList.add("body-overflow");
          let message =
            (errorMessage && errorMessage.message) || response.message;
          setErrorMessage(message);
        } else {
          sendKeyAfterChangedNumber();
        }
      }
    );
  };
  const renderContent = () => {
    if (errorMessage) {
      return (
        <AppErrors
          message={errorMessage}
          onClickClose={() => setErrorMessage(false)}
        />
      );
    } else if (info.message) {
      return (
        <AppInfo
          message={info.message}
          title={info.title}
          onSubmit={onCloseSection}
          buttonText="Close anyway"
          onClickClose={() => setInfo({ message: "", title: "" })}
        />
      );
    } else {
      return (
        <div>
          <div className="modal-bg" />
          <div className="modal">
            {/* Header */}
            <div className="head-general with-back">
              <a href="javascript: void(0)" className="back" />
              <h4>
                {(changeNumber && "Change Phone Number") || "Sms Verification"}
              </h4>
              <a onClick={onClose} href="javascript: void(0)" className="close">
                <icon className="icon icon-close" />
              </a>
            </div>
            {/* Header */}

            <div className="sms-page white-bg">
              <div className="modal-body">
                <div className="row center-sm">
                  <div className="col-sm-7">
                    {(changeNumber && (
                      <>
                        <PhoneInput
                          smsVerification={true}
                          submitPhoneNumber={submitPhoneNumber}
                          defaultNumber={newMobileNumber}
                        />
                        <div className="">
                          <button
                            onClick={saveNewNumber}
                            className={`btn btn-sign login-button fixed-btn ${(activeButton &&
                              "active") ||
                              ""}`}
                            disabled={!activeButton}
                          >
                            <span>Save</span>
                          </button>
                        </div>
                      </>
                    )) || (
                      <>
                        <form className="head d-flex justify-content-around align-items-center">
                          <input
                            type="tel"
                            maxLength="1"
                            id="sms1"
                            name="sms1"
                            value={sms1}
                            defaultValue={sms1}
                            className="sms-verification"
                            onChange={handleChangeInput}
                            autoFocus
                          />
                          <input
                            type="tel"
                            maxLength="1"
                            id="sms2"
                            name="sms2"
                            value={sms2}
                            defaultValue={sms2}
                            className="sms-verification"
                            onChange={handleChangeInput}
                          />
                          <input
                            type="tel"
                            maxLength="1"
                            id="sms3"
                            name="sms3"
                            value={sms3}
                            defaultValue={sms3}
                            className="sms-verification"
                            onChange={handleChangeInput}
                          />
                          <input
                            type="tel"
                            maxLength="1"
                            id="sms4"
                            name="sms4"
                            value={sms4}
                            defaultValue={sms4}
                            className="sms-verification"
                            onChange={handleChangeInput}
                          />
                        </form>
                        <div className="d-flex align-items-center justify-content-center change-number">
                          <div>
                            <span>{newMobileNumber}</span>{" "}
                            <a
                              href="javascript:void(0)"
                              onClick={handleChangeMobileNumber}
                            >
                              Change
                            </a>
                          </div>
                        </div>
                        <div className="foot d-flex align-items-center justify-content-between">
                          <a
                            href="javascript:void(0)"
                            onClick={sendSmsVerificationKey}
                          >
                            Send again
                          </a>
                          <p className="d-flex">
                            <icon className="icon icon-time" />
                            <CountdownTimer onTimeout={onTimeout} />
                          </p>
                        </div>

                        <div className="fixed-btn checkout-btn">
                          <a
                            href="javascript: void(0)"
                            className=""
                            onClick={e => handleVerificateSms(e)}
                          >
                            <span>Verify my phone number</span>
                          </a>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {/* .col-sm-8 */}
                {/* .row */}
              </div>
              {/* .modal-body */}
            </div>
            {/* .sms-page */}
          </div>
          {/* .modal */}
        </div>
      );
    }
  };
  return renderContent();
};

export default SmsVerification;
